import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Urban Green Infrastructure</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-green-infrastructure/urban-green-infrastructure.png'} alt={'urban green infrastructure'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p>{`Zhang J, `}<strong parentName="p">{`Song J`}</strong>{` (2026), `}<Link href={'https://doi.org/10.5194/egusphere-egu26-2289'} mdxType="Link">{`Modeling the Impact of Vegetation Dynamics on Urban Microclimate and Building Energy Demand. `}<em parentName="p">{`European Geosciences Union 2026 (EGU)`}</em>{`, May 2026, Vienna, Austria.`}</Link></p>
      <p>{`Zhang J, `}<strong parentName="p">{`Song J`}</strong>{` (2025), Assessing the Cooling and Carbon Sequestration Potential of Urban Green Spaces via an Advanced Urban Canopy Model. `}<em parentName="p">{`22nd Asia Oceania Geosciences Society (AOGS) Annual Meeting`}</em>{`, July 2025, Singapore.`}</p>
      <p>{`Zhang J, `}<strong parentName="p">{`Song J`}</strong>{` (2025), Mechanisms of Urban Green Space Irrigation Impacts on the Water-Heat-Carbon Coupled System in the Built Environment. `}<em parentName="p">{`12th International Conference on Urban Climate (ICUC12)`}</em>{`, July 2025, Rotterdam, Netherlands.`}</p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H (2016). `}<Link href={'https://iopscience.iop.org/article/10.1088/1748-9326/11/11/114018/pdf'} mdxType="Link">{`Diurnal changes in urban boundary layer environment induced by urban greening. `}<em parentName="p">{`Environmental Research Letters`}</em>{`, 11(11):114018.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H (2015). `}<Link href={'https://doi.org/10.1016/j.buildenv.2015.10.016'} mdxType="Link">{`Impacts of mesic and xeric urban vegetation on outdoor thermal comfort and microclimate in Phoenix, AZ. `}<em parentName="p">{`Building and Environment`}</em>{`, 94, 558-568.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      